module.exports = __webpack_public_path__ + "static/media/sg.4caaaac2.svg";